// extracted by mini-css-extract-plugin
export default {"listItem":"RelatedCard_listItem__6PRu6","relatedTitle":"RelatedCard_relatedTitle__AT0cM"};